import React, {useState} from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { connect } from "react-redux";
import './css/index.css';
import CheckoutForm from "./checkout_form.js"
import {loadStripe} from '@stripe/stripe-js';

// Media Imports
import BackImg from "./media/BackImg.svg"
import CancelImg from "./media/cancel-sub.png"
import icon from './media/icon.png'
import upgrade from './media/upgrade.png'
import monthly from './media/monthly.png'
import due from './media/due.png'
import empty from './media/empty.png'
import success from './media/success.png'
import loader from "../../../Assets/loaderTransaparent.gif"
import { checkPayment } from "../../../Redux/actions/billingPayment";
import { addNotification } from "../../../Utilities/notifications.js";
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import {sendMail,pausePayment} from "../../../Redux/actions/billingPayment"
import phoneNumbers from "../../../Utilities/phoneNumbers";
import CustomModal from "../../../UtilityComponents/customModal";
import NotificationModal from './notificationModal';


const stripePromise = loadStripe('pk_test_OOwZosnv89LgW5S85qEph4J100Larw7ULS');
class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      payment_flag : undefined,
      amount:-1,
      plan: 'year',
      cust_id:"",
      show_page : undefined,
      upgrade_flag :false,
      show_success: false,
      selection_plan : 'standard',
      name:"",
      email:"",
      phone:"",
      modal:false,
      pause_flag:"",
      loading:false
    }
    this.check_payment();
  }

  async check_payment(){
    if(this.props.user.subscription_id == 0) return
    // TODO: Make API call to check whether user has updated his payment details or not.

    let obj=await checkPayment()
    if(obj.status != 200){
      let error_screen = true
    }
    let payment_flag = obj.data.payment //considering he did not updated his payment details
    let data = obj.data
    this.state.payment_flag = payment_flag
    let date = this.date_converter(data.current_period_end)
    let amount = data.amount
    if(data.stripe_plan_type == 'year'){
      amount = amount*12
      amount = amount.toLocaleString()
    }
    this.setState ({payment_flag:payment_flag,pause_flag:obj.data.pause_sub,cust_id:obj.data.cust_id,amount:amount,plan_type:data.stripe_plan_type,next_bill_date:date,transactions:obj.data.transactions})
    // return false
  }
  onPhoneNumberChange = async(phn,obj) => {
    let result = phoneNumbers.filter(i => i.countryCode === obj.countryCode) ;      
    let format=phn.replace(/[^\w\s]/gi, '')
    let phnNumber=format.replace(/ /g,'')      
    this.setState({
      phone:phn
    })
  }
  handleChange = (e) =>{
    this.setState({[e.target.name]:[e.target.value]});
  }
  handleSubmit = async (e) => {
    e.preventDefault()
    let payload = {
            "name" : this.state.name.toString(),
            "email" : this.state.email.toString(),
            "phone" : this.state.phone.toString(),
          }  
    let obj= await sendMail(payload)           
 
    if(obj.status === 200){
          addNotification({
            title: "Techforce.ai",
            message: "Mail has been sent to sales@techforce.ai",
            type: "success"
          });
    }
  }
  contact_form() {  
    this.setState({
      selection_plan:"enterprise"
    })  
  }
  activeMonthPlan = () => {
    this.setState({plan:'month'})
  }
  activeYearPlan = () => {
    this.setState({plan:'year'})
  }
  date_converter (date) {
    var dateObj = new Date(date);
    var month = dateObj.getUTCMonth()
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    let month_array = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    return `${month_array[month]} ${day}-${year}`;
  }
  show_success_page = () => {
    this.setState({show_success:true})
  }
  get_success_component() {
    return (
      <div className="success-page">
        <img src={success} alt="Success!" height="20%" className="success-page-image"  />
        <div className="success-page-main-message"> Congratulations! Your subscription to Standard eWorker is successful.</div>
        <div className="success-page-sub-message"> An invoice will be generated soon which can be downloaded from EM Console billing page.</div>
        <button className="success-page-button" onClick={()=>{window.location.reload(false)}}> {"Billing Page"} </button>
      </div>
    )
  }
  contact_now_upgrade = () => {
    addNotification({
      title: "Success",
      message: "Thank you for your interest in our Enterprise endition! our team will get back to you soon.",
      duration: 5000,
      type: "success"
    });
    this.setState({show_page:"billing"})
  }
   
  get_component() {
      return (
      <div>
         <Elements stripe={stripePromise} >
           <CheckoutForm user={this.props.user} plan={this.state.plan} upgrade={this.state.upgrade_flag} show_success_page={this.show_success_page}/>   
         </Elements>
         <button className="backbtn" onClick={()=>{this.setState({show_page:undefined})}}><img src={BackImg} style={{width:"15px",marginRight:"10px",  transform: "rotate(180deg)"}} />Back</button>
      </div>
      )
  }
  render_community() { 
    return(
      <div className="billing-default-container">
        <div className="billing-tiles">
          <div className="billing-tile-plan">
            <img className="billing-plan-icon" src={icon} alt="plan" />
            <div className="billing-plan-tile-label">
              CURRENT PLAN
            </div>
            <div className="billing-plan-tile-name">
            {this.props.user.subscription_id == 0? "Community":"Standard"}
            </div>
          </div>
          <div className="billing-tile-amount">
            <img className="billing-plan-icon" src={monthly} alt="plan" />
            <div className="billing-plan-tile-label">
              CURRENT BILL
            </div>
            <div className="billing-plan-tile-name">
              --
            </div>
          </div>
          <div className="billing-tile-payment-date">
            <img className="billing-plan-icon" src={due} alt="plan" />
            <div className="billing-plan-tile-label">
            NEXT PAYMENT DATE
            </div>
            <div className="billing-plan-tile-name">
             --
            </div>
          </div>
        </div>
        <div className="billing-upgrade-band">
            <img className="billing-upgrade-band-icon" src={upgrade} alt="plan" />
          <div className="billing-upgrade-band-text">
            <div className="billing-upgrade-band-text-heading">
              Want to upgrade plan?
            </div>
            {this.props.user.subscription_id == 0 ?
            <div className="billing-upgrade-band-text-info">
              Upgrade to Standard eWorker.
            </div>:""}
          </div>
          <div className="billing-upgrade-band-button">
            <button className="billing-upgrade-band-button-button" onClick={()=>this.change_page("payment")}>UPGRADE</button>
          </div>
        </div>
      </div>
    )
  }
  change_page = (page) => {  
    let selection_plan =  'standard' 
    this.setState({show_page:page,upgrade_flag:true,selection_plan:selection_plan})
  }
   pause_payment =  async() => {
     this.setState({
       loading:true
    })
    let payload = {
      cust_id:this.state.cust_id,
    }
    let status = await pausePayment(payload)
    if(status == 200){
      this.setState({
        loading:false
      })
      this.toggle()
      this.check_payment()
    }
  }
  toggle = () => {
   this.setState({
     modal:!this.state.modal
   })
  }
  render_default() { 
    return(
      <div className="billing-default-container">
        <div className="billing-tiles">
          <div className="billing-tile-plan">
            <img className="billing-plan-icon" src={icon} alt="plan" />
            <div className="billing-plan-tile-label">
              CURRENT PLAN
            </div>
            <div className="billing-plan-tile-name">
              Standard eWorker
            </div>
          </div>
          <div className="billing-tile-amount">
            <img className="billing-plan-icon" src={monthly} alt="plan" />
            <div className="billing-plan-tile-label">
              CURRENT {this.state.plan_type == "month" ? "MONTHLY" : "YEARLY"} BILL
            </div>
            <div className="billing-plan-tile-name">
              ${this.state.amount}
            </div>
          </div>
          <div className="billing-tile-payment-date">
            <img className="billing-plan-icon" src={due} alt="plan" />
            <div className="billing-plan-tile-label">
            NEXT PAYMENT DATE
            </div>
            <div className="billing-plan-tile-name">
             {this.state.pause_flag == "void"?"Subscription Paused":this.state.next_bill_date}
            </div>
          </div>
          {this.state.payment_flag ? 
          <div className="billing-tile-payment-date">
            <div className="rounded-logo">
            <img  src={CancelImg} alt="plan" width="20"/></div>
            <div className="billing-plan-tile-label">
              CANCEL SUBSCRIPTION
            </div>
            <div className="billing-upgrade-cancel-button">
            <button className="billing-upgrade-cancel-button-button" onClick={()=>this.pause_payment()} style={{width:"150%"}}>         
            { this.state.loading? <i className="fas fa-circle-notch fa-spin play"></i> : "CANCEL"}
            </button>
          </div>
          </div>:""}
        </div>
        <div className="billing-upgrade-band">
            <img className="billing-upgrade-band-icon" src={upgrade} alt="plan" />
          <div className="billing-upgrade-band-text">
            <div className="billing-upgrade-band-text-heading">
              Want to upgrade plan?
            </div>
            <div className="billing-upgrade-band-text-info">
              Upgrade to Enterprise eWorker.
            </div>
          </div>
          <div className="billing-upgrade-band-button">
            <button className="billing-upgrade-band-button-button" onClick={()=>this.change_page("payment")}>UPGRADE</button>
          </div>
        </div>
      {this.get_payment_history_component()}
      <div>
          { this.state.modal ? <CustomModal comp={<NotificationModal  toggle={() => this.toggle()}/>} 
                toggle={() => this.toggle()}
                name=""
                modal={this.state.modal} /> : null 
          }
      </div>

      </div>
    )
  }
  format_date_for_payment = (date) => {
    date = new Date(date);
    let month_array = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    return `${date.getUTCDate()} ${month_array[date.getUTCMonth()]}, ${date.getUTCFullYear()} ${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()}`
  }
  get_payment_history_component = () => {
    if(this.state.transactions.length == 0){
      return (  <div className="billing-payment-history">
        <div className="billling-payment-hstory-empty">
          <img className="billling-payment-hstory-empty-icon" src={empty} alt="plan" height="300px" width="300px"/>
          <div className="billling-payment-hstory-empty-head">Payment History</div>
          <div className="billling-payment-hstory-empty-text">You don't have any payments now</div>
        </div>
      </div>)
    }
    else {
      let rows = []
      let index = 0
      for(let itr of this.state.transactions) {
        rows.push(
          <tr key={index++} className="payment-history-table-row">
            <td>{this.format_date_for_payment(itr.created)}</td>
            <td className={itr.status == "paid"?"payment-success":"payment-failure"}>{itr.status}</td>
            <td>{itr.amount_paid}</td>
            <td><a href={itr.pdf}>pdf</a></td>
          </tr>
        )
      }
      return (
        <div className="billing-payment-history">
          <div className="payment-history-heading">
            Payment History
          </div>
          <div className="payment-history-body">
            <table className="payment-history-table">
              <thead>
                <tr className="payment-history-table-head">
                  <th> Date </th>
                  <th> Status </th>
                  <th> Amount </th>
                  <th> Invoice </th>
                </tr>
              </thead>
              <tbody>
                {rows}
              </tbody>
            </table>
          </div>
        </div>
      )
    }
  }
  render_payment(){

    let text = <div className="recurring-amount"><b>Please select a plan from above</b></div>
    let amount = <div className="amount"></div>
    if(this.state.plan == 'month'){
      text = <div className="recurring-amount">Billed <b>Monthly</b> the amount of</div>
      amount = <div className="amount">$199 </div>
    }
    else if (this.state.plan == 'year'){
      let temp = (149*12).toLocaleString()
      amount = <div className="amount">${temp}</div>
      text = <div className="recurring-amount">Billed <b>Yearly</b> the amount of</div>
    }
    return (<div className="billing-container1">
        <div className="billing-left-pane">
          <div className="billing-pane-heading">
            Billing Details
          </div>
          <div className="billing-left-pane-body">
            {this.get_component()}
          </div>
        </div>
        <div className="billing-right-pane">
          <div className="billing-pane-heading">
            Plan Details
          </div>
          <div className="billing-right-pane-body">
            <div className="billing-plan-titles">
            <div className={this.state.selection_plan == 'standard' ? 'billing-plan-name-left active' : 'billing-plan-name-left'} onClick={()=>{this.setState({selection_plan:"standard"})}}>STANDARD</div>
              <div className={this.state.selection_plan == 'enterprise' ? 'billing-plan-name-left active' : 'billing-plan-name-left'} onClick={()=>{this.setState({selection_plan:"enterprise"})}}>ENTERPRISE</div>
            </div>
            
            <div className="billing-plan-details">
            {this.state.selection_plan == 'standard' ?
            <div>
              <img className="billing-plan-icon" src={icon} alt="plan" />
              <br/>
              <div className="billing-plan-fame">MOST POPULAR</div>
              <div className="billing-plan-name">{this.state.selection_plan == 'standard' ? 'Standard eWorker' : 'Enterprise eWorker'}</div></div>:""}
              {this.state.selection_plan == 'standard' ?
              <div className="billing-plan-details-list" style={{marginLeft:"-29px"}}>
                <ul>
                  <li> 1(One) cloud E-Worker Machines allowed (TFAI Cloud)</li>
                  <li> UNLIMITED local E-Worker machines allowed</li>
                  <li> Unattended Support</li>
                  <li> Access to Cloud E-Worker Machine</li>
                  <li> Multi-Tenant/Multi-Threading</li>
                  <li> Uptime Guarantee 99%</li>
                  <li>Standard - Online Support</li>
                </ul>
              </div>: <div className="billing-plan-details-list">
                <div  style={{fontSize:"14px",color:"black",paddingBottom:"15px",marginLeft:"2px"}}>Get in touch with our Sales team:</div>
                <form className="form-container" onSubmit={this.handleSubmit}>
                  <div className="form-group">
                      <label htmlFor="exampleInputEmail1" style={{fontSize:"13px",marginLeft:"4px"}}>Name</label>
                      <input type="text" className="form-control-2" name="name" onChange={this.handleChange} value={this.state.name} placeholder="Enter" required></input>
                  </div>
                  <div className="form-group">
                      <label htmlFor="exampleInputEmail2" style={{fontSize:"13px",marginLeft:"4px"}}>Email</label>
                      <input type="text" className="form-control-2" name="email" onChange={this.handleChange} value={this.state.email}placeholder="Enter" required></input>
                  </div>
                  <div className="form-group ">
                    <label htmlFor="contactNumber" style={{fontSize:"13px",marginLeft:"4px"}}>Phone</label>
                    <div className="billing-1">
                      <ReactPhoneInput
                        inputExtraProps={{
                          name: "phone",
                          required: true,
                          autoFocus: true
                        }}
                        style={{width:"96%"}}
                        country={"in"}
                        value={this.state.phone}
                        onChange={this.onPhoneNumberChange}
                      />
                    </div>
                  </div>
                  <div className="text">
                      <button className="billing-btn" type="submit" onSubmit={this.handleSubmit}> Submit </button>
                  </div>
                </form>
              </div>
            }
            {this.state.selection_plan == 'standard' ?
              <div className="billing-plan-durations">
                <button className={`${this.state.plan=='month'?'billing-plan-duration-left active':'billing-plan-duration-left'}`} onClick={()=>this.activeMonthPlan()}>MONTHLY</button>
                <hr></hr><button className={`${this.state.plan=='year'?' billing-plan-duration-right active':'billing-plan-duration-right'}`} onClick={()=>this.activeYearPlan()}>YEARLY</button>
              </div>:""
            }
            </div>
            {this.state.selection_plan == 'standard' ?
              <div className="payment-amount">
                  {text}
                  {amount}
              </div>:""
            }
          </div>
        </div>
    </div>)
  }
  render () {
      document.title = "Billing | E-Manager Console | Techforce.ai";
      if(this.state.show_success == true) return this.get_success_component()
      // When a community user opens and this would be default
      if(this.props.user.subscription_id == 0 && this.state.show_page == undefined) return this.render_community()       
      //Based on the user journey show the components. Whether he wants to upgrade from from community or from standard eWorker etc
      if(this.state.show_page == 'payment') return this.render_payment()
      else if (this.state.show_page == "billing" && this.props.user.subscription_id == 0) return this.render_community()
      else if (this.state.show_page == "billing" && this.props.user.subscription_id == 1) return this.render_default()

      //This would be default for existing customers
      if(this.state.payment_flag) return this.render_default()
      // else if(this.state.payment_flag == false) return this.render_payment()
      else if(this.state.payment_flag == false && this.props.user.subscription_id == 1) return this.render_community()

      else return (<div> Checking payment stats.... </div>)
  }
}

const mapStateToProps = (state) => ({
    user: state.user
})


export default connect(mapStateToProps, null)(App);
